"use client";

import { getApiBaseAddress } from "@/lib/tenant/helpers";
import { auth, useSafeRequestSwr } from "@osn/auth";
import { ApiRequestOptions, TenantService } from "osn-participantapi-client";

export function useTenantSettings() {
  const callback = async (options: ApiRequestOptions) => await TenantService.getTenantSettings(options);
  const key = () => ["TenantService.getTenantSettings"];
  return useSafeRequestSwr(callback, key);
}

export function useTenantSignupSettings() {
  const callback = async () => {
    await auth.authStateReady();
    const tenantId = auth.currentUser!.tenantId!;
    const apiUrl = getApiBaseAddress();
    const result = await fetch(apiUrl + "/signup/emailInfo", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "X-OSN-TENANT": tenantId,
      },
    });

    if (!result.ok) {
      throw new Error(result.statusText);
    }

    const responseData = await result.json();

    return responseData.data as Promise<{ displayName: string; noReplyEmail: string }>;
  };

  const key = ["TenantService.getTenantSignupSettings"];
  return useSafeRequestSwr(callback, key);
}
